import request from '@/api/request.js'

const apis = {
  readSkus(params) {
    return request({ url: `/admin_activation_code/readSkus`, method: 'POST', data: params })
  },
  readSkuPage(params) {
    return request({ url: `/admin_activation_code/readSkuPage`, method: 'POST', data: params })
  },
  readOneSku(params) {
    return request({ url: `/admin_activation_code/readOneSku`, method: 'POST', data: params })
  },
  saveSku(params) {
    return request({ url: `/admin_activation_code/saveSku`, method: 'POST', data: params })
  },
  deleteSku(params) {
    return request({ url: `/admin_activation_code/deleteSku`, method: 'POST', data: params })
  },
  create(params) {
    return request({ url: `/admin_activation_code/create`, method: 'POST', data: params })
  },
  readUnused(params) {
    return request({ url: `/admin_activation_code/readUnused`, method: 'POST', data: params })
  },
}

export default apis
